export default function  searchFunction(keyword){
    let pages = [
        {
            name:'Actumjs',
            link:'/',
            keywords:'Actumjs A state management library for javascript app. Light weight Easy to use Portable ',
            description:''
        },
        {
            name:'Get Started',
            link:'/get-started',
            keywords:'Actumjs What is Actumjs? Why Actumjs? Installation Using NPM Using Yarn With browser script tag Core Concept  Store Actions Listeners',
            description:''
        },
        {
            name:'Api Reference',
            link:'/api',
            keywords:'Actumjs API Reference Using with script tag Using with import statement  Creating store addAction before after removeAction replaceActionCallback trigger getState Adding actions Listening to actions Removing Listener Removing an action Trigger an action Replacing an action callback Reading Data from store Directory structure',
            description:''
        },
        {
            name:'Examples',
            link:'/examples',
            keywords:'Actumjs Examples Using with Reactjs Using with Vuejs Todo App with Reactjs Todo App With Vuejs',
            description:''
        },
    ];
   return pages.filter((p)=>p.keywords.toLowerCase().includes(keyword.trim().toLowerCase()));
}
